import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { DatePicker } from 'rsuite';

const DateTimePicker = forwardRef(({
    value,
    onChange,
    minDateTime = null,
    label = null,
    placeholder = "dd/MM/yy hh:mm",
    format = "dd/MM/yy hh:mm aa",
    oneTap = false,
    showWrapper = true,
    menuClassName = ""
}, ref) => {

    const wrapperRef = useRef(null);
    const pickerRef = useRef(null);


    useImperativeHandle(ref, () => ({
        open: () => {
            pickerRef.current?.open?.();
        }
    }));

    const pickerComponent = (
        <DatePicker
            ref={pickerRef}
            value={value ? new Date(value) : null}
            onChange={onChange}
            oneTap={oneTap}
            placeholder={placeholder}
            format={format}
            showMeridiem
            menuClassName={menuClassName}
            container={() => wrapperRef.current}
            disabledDate={date => {
                if (!minDateTime) return false;

                const minDate = new Date(minDateTime);
                const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                const minDateOnly = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());

                return dateOnly < minDateOnly;
            }}
        />
    );

    if (!showWrapper) return pickerComponent;

    return (
        <div className="bottom-calendar" ref={wrapperRef}>
            {label && <h6>{label}</h6>}
            <div className="option-field" style={{ position: 'relative' }}>
                <div className="rsuite-wrapper">
                    {pickerComponent}
                </div>
            </div>
        </div>
    );
});

export default DateTimePicker;